import { render } from "./App.vue?vue&type=template&id=b008ecc4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b008ecc4&scoped=true&lang=css"

import exportComponent from "D:\\git\\Homepage\\vue3home\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b008ecc4"]])

export default __exports__